import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { CATEGORIES } from "../data/store";

const CategoryCard = ({ category }) => {
  const Icon = Icons[category.icon] || Icons.Package;
  return (
    <Link
      to={`/loja?cat=${category.slug}`}
      data-testid={`category-card-${category.slug}`}
      className="group flex flex-col items-center justify-center gap-3 p-5 bg-white border border-slate-200 rounded-lg hover:border-brand hover:shadow-md transition-all duration-200 text-center"
    >
      <span className="h-14 w-14 rounded-full bg-brand-light flex items-center justify-center group-hover:bg-brand transition-colors">
        <Icon className="h-6 w-6 text-brand group-hover:text-white transition-colors" />
      </span>
      <span className="text-sm font-semibold text-slate-800 leading-tight">
        {category.name}
      </span>
    </Link>
  );
};

export const CategoryGrid = () => (
  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
    {CATEGORIES.map((c) => (
      <CategoryCard key={c.slug} category={c} />
    ))}
  </div>
);

export default CategoryCard;
